<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("DistributionUser.import.title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              @click="
                dialog = false;
                $emit('close');
              "
            >
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
        <v-data-table
          :headers="Headers"
          :items="items"
          multi-sort
          disable-pagination
          hide-default-footer
         class="elevation-0 px-6 pb-2"
        >
          <template v-slot:top>
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="Body 2 secondary--text pt-2">
                  <span class="red--text">
                    {{ $t("DistributionUser.import.hint", [$consts.shopName()]) }}
                  </span>
                </span>
              </v-row>
            </v-toolbar>
          </template>
        </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          outlined
          @click="
            $emit('close');
            dialog = false;
          "
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "importResultDialog",

  props: {
    value: Boolean,
    items: Array,
  },

  data: () => ({
    dialog: false,
  }),

  computed:{
     Headers() {
      return [
        {
          text: i18n.t("DistributionUser.import.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_code",
        },
        {
          text: i18n.t("DistributionUser.import.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_name",
        },
        {
          text: i18n.t("DistributionUser.import.distribution_user_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "distribution_user_name",
        },
      ];
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>
